"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldTrueSize = exports.ModelMutatorTrueSize = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorTrueSize = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorTrueSize, _super);
    function ModelMutatorTrueSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorTrueSize.prototype.add = function (captureId) {
        var stateValue = this.field.stateValue != null ? this.field.stateValue.slice() : [];
        if (stateValue.find(function (cId) { return captureId === cId; })) {
            return;
        }
        stateValue.push(captureId);
        this.state.setFieldValue(this.field.id, stateValue);
    };
    ModelMutatorTrueSize.prototype.copy = function (from) {
        for (var _i = 0, _a = from.getCaptures(); _i < _a.length; _i++) {
            var capture = _a[_i];
            this.add(capture.objectId);
        }
        return true;
    };
    ModelMutatorTrueSize.prototype.clear = function () {
        var collection = this.field.collection;
        var usedCaptures = this.getUsedCaptures();
        for (var _i = 0, _a = this.field.getCaptures(); _i < _a.length; _i++) {
            var capture = _a[_i];
            var drawableState = collection.getDrawableState(capture.objectId);
            // Don't remove markers if TS capture is used by another field
            if (drawableState != null && !usedCaptures[capture.objectId]) {
                drawableState.Mutator.clear();
            }
        }
        this.state.setFieldValue(this.field.id, null);
    };
    ModelMutatorTrueSize.prototype.getUsedCaptures = function () {
        var _this = this;
        var usedCaptures = {};
        var captureIds = this.state.getFieldValue(this.field.id);
        if (captureIds == null || captureIds.length === 0) {
            return usedCaptures;
        }
        var collection = this.field.collection;
        collection.forEachField(function (currentField) {
            if (!CollectionModelFieldTrueSize.isTrueSizeField(currentField) || currentField.id === _this.field.id) {
                return;
            }
            var currentCaptures = currentField.getCaptures();
            for (var _i = 0, currentCaptures_1 = currentCaptures; _i < currentCaptures_1.length; _i++) {
                var currentCapture = currentCaptures_1[_i];
                if (captureIds.indexOf(currentCapture.objectId) !== -1) {
                    usedCaptures[currentCapture.objectId] = true;
                }
            }
        });
        return usedCaptures;
    };
    return ModelMutatorTrueSize;
}(collection_field_1.ModelMutator));
exports.ModelMutatorTrueSize = ModelMutatorTrueSize;
var CollectionModelFieldTrueSize = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldTrueSize, _super);
    function CollectionModelFieldTrueSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldTrueSize.isTrueSizeField = function (f) {
        return f.schema.type === CollectionModelFieldTrueSize.TYPE;
    };
    Object.defineProperty(CollectionModelFieldTrueSize.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorTrueSize(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldTrueSize.prototype, "value", {
        get: function () {
            var captureIds = this.stateValue || [];
            var output = [];
            for (var _i = 0, captureIds_1 = captureIds; _i < captureIds_1.length; _i++) {
                var captureId = captureIds_1[_i];
                var capture = this.collection.state.getCapture(captureId);
                if (capture == null) {
                    throw new Error("Field \"".concat(this.id, "\": Cannot find capture ").concat(captureId));
                }
                output.push(capture);
            }
            return output;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldTrueSize.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldTrueSize.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds()
            .map(function (c) { return _this.collection.state.getCapture(c); })
            .filter(function (c) { return !!c; }); // Handle fetchable returning "null" when race conditions occur
    };
    CollectionModelFieldTrueSize.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldTrueSize.prototype.getCaptureIds = function () {
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return this.stateValue;
    };
    CollectionModelFieldTrueSize.prototype.hasValue = function () {
        return this.value.length > 0;
    };
    CollectionModelFieldTrueSize.TYPE = core_api_1.IkeFieldType.TRUE_SIZE;
    return CollectionModelFieldTrueSize;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldTrueSize = CollectionModelFieldTrueSize;
//# sourceMappingURL=true.size.field.js.map